import { createContext } from 'react'

const context = createContext('learningResources')

export default context